require('./bootstrap');
import Vue from 'vue'
import InstantSearch from 'vue-instantsearch'
import Notifications from 'vue-notification'
import vueCountryRegionSelect from 'vue-country-region-select'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import page_header from './components/Header.vue'
import page_footer from './components/Footer.vue'
import top_category from './components/TopCategory.vue'
import brand_slider from './components/BrandSlider.vue'
import features_block from './components/Features.vue'
import banners_block from './components/Banners.vue'
import latest_products from './components/LatestProduct.vue'
import main_slider from './components/MainSlider.vue'
import products from './components/Product.vue'
import product_details from './components/ProductSingle.vue'
import similar_products from './components/SimilarProduct.vue'
import shopping_cart from './components/Cart.vue'
import checkout from './components/Checkout.vue'
import thank_you from './components/ThankYou.vue'
import search from './components/Search.vue'
import accept_order from './components/seller/AcceptOrder.vue'
import pending_order from './components/seller/PendingOrder.vue'
import search_algolia from './components/web/SearchAlgolia.vue'

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notifications);
Vue.use(vueCountryRegionSelect);
Vue.use(InstantSearch);
Vue.component('pagination', require('laravel-vue-pagination'));

const app = new Vue({
    el: '#app',
    components: { 
        page_header,
        page_footer,
        top_category,
        brand_slider,
        features_block,
        banners_block,
        latest_products,
        main_slider,
        products,
        product_details,
        similar_products,
        shopping_cart,
        checkout,
        thank_you,
        search,
        accept_order,
        pending_order,
        search_algolia
    }
});
